import { CreateUpdateSeatingModelDetailModel } from '@/__generated';
import { BusEntityType } from '@/constants';
import { Card } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  seats: CreateUpdateSeatingModelDetailModel[];
};

export default function BusSummary({ seats }: Props) {
  const { t } = useTranslation();
  const info = React.useMemo(() => {
    return {
      totalSeats: seats.filter(x => x.busEntityType === BusEntityType.Seat).length,
      toiletRight: seats.filter(x => x.busEntityType === BusEntityType.ToiletRight).length,
      ToiletLeft: seats.filter(x => x.busEntityType === BusEntityType.ToiletLeft).length,
      fridge: seats.filter(x => x.busEntityType === BusEntityType.Fridge).length,
      door: seats.filter(x => x.busEntityType === BusEntityType.Door).length,
    };
  }, [seats]);
  return (
    <Card className="mtopo-card" size="small" title={t('seatModelsPage_BusSummary')}>
      <div className="bus-summary">
        <div className="item">
          Seats
          <b>{info.totalSeats}</b>
        </div>
        <div className="item">
          {t('Toilet Right')}
          <b>{info.toiletRight}</b>
        </div>
        <div className="item">
          {t('Toilet left')}
          <b>{info.ToiletLeft}</b>
        </div>
        <div className="item">
          Door
          <b>{info.door}</b>
        </div>
        <div className="item">
          Fridge
          <b>{info.fridge}</b>
        </div>
      </div>
    </Card>
  );
}
